export default __webpack_public_path__ + "static/media/warning.3daeeda5.svg";